import axios from "axios";
import spinnerInterceptor from "../interceptors/spinner.interceptor";
import authTokenInterceptor from "../interceptors/auth-token-iw.interceptor";

const http = axios.create({
  baseURL: window.location.origin,
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/vnd.appetize+json;version=1"
  }
});

authTokenInterceptor.wrapAxios(http);
spinnerInterceptor.wrapAxios(http);

function applePayGetAuth(showSpinner = true) {
  return http.post(
    `/auth/elavon`,
    {},
    {
      showSpinner
    }
  );
}

function applePayGetSession(values, vendor, showSpinner = true) {
  return http.post(`/merchant_session`, values.reqBody, {
    showSpinner,
    headerType: "Authorization",
    headerValue: `Bearer ${values.token}`
  });
}

export default {
  applePayGetAuth,
  applePayGetSession
};
